import axios from 'axios/index';
import env from './config/env';
import jwtDecode from 'jwt-decode';

export function login(phoneNumber, smsCode) {
  return axios
    .post(`${env.backendUrlPrefix}/auth/login`, `phone=${encodeURIComponent(phoneNumber)}&smsCode=${smsCode}`, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
    .then(function(loginResponse) {
      const token = loginResponse.data.token;
      return token;
    });
}

export function parseJwtToken(token) {
  return jwtDecode(token);
}



// WEBPACK FOOTER //
// ./src/authService.js